import { Card } from "@mui/material"
import PortUtils from "../portlibs/PortUtils"
import useCashSummary from "../portlibs/useCashSummary";

function PerformanceCard(props:{title:string, gain:number, currency:number, performance:number}) {
    return <Card className="card">
        <h4>{props.title}</h4>
        <div className="flex horz gap-16">
            <div className={props.gain<0 ? "red" : ""}>{PortUtils.formatCurrency(props.currency, props.gain)}</div>
            <div className={(props.gain>0 ? "green" : "red") + " w700"}>{PortUtils.formatNumber(props.performance)}%</div>
        </div>
    </Card>
}

export default function Performance(){
    const  { gain_ca, gain_us, performance_ca, performance_us} = useCashSummary()
   return <div className="performance flex gap-16">
        <PerformanceCard title="GAIN C$" performance={performance_ca} gain={gain_ca} currency={0}/>
        <PerformanceCard title="GAIN U$" performance={performance_us} gain={gain_us} currency={1}/>
    </div>
}